<template lang="html">
  <section class="news">
    <div class="row">
      <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
        <p style="position: absolute; color: White; top: 40%; left: 40%;">
          <img src='../../assets/snakes.gif' />
        </p>
      </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Add Hospital</h4>
            <form class="form-sample" @submit="onSubmit">
              <p class="card-description">
                <strong>Basic info</strong>
              </p>
              <p style="color:red;">{{error}}</p>
              <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="Name">
                    <b-form-input type="text" v-model="name" required=""></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Latitude">
                    <b-form-input type="text" v-model="lat" required=""></b-form-input>
                  </b-form-group>
                  </div>
                  </div>
                       <div class="row">
                          <div class="col-md-6">
                  <b-form-group horizontal label="Longitude">
                    <b-form-input type="text" v-model="lon" required=""></b-form-input>
                  </b-form-group>
                </div>
                    <div class="col-md-6">
                       <b-form-group horizontal label="DistrictName">
                   <b-form-input type="text" v-model="district" required=""></b-form-input>
                   </b-form-group>
                  </div>
                    <div class="col-md-6">
                    <b-form-group horizontal label="State">
                    <b-form-input type="text" v-model="state" required=""></b-form-input>
                  </b-form-group>
                  </div>
                   <div class="col-md-6">
                       <b-form-group horizontal label="Address">
                   <b-form-input type="text" v-model="address" required=""></b-form-input>
                   </b-form-group>
                  </div>
                    <div class="col-md-6">
                    <b-form-group horizontal label="MobileNo">
                    <b-form-input type="text" v-model="mobileno" required=""></b-form-input>
                  </b-form-group>
                  </div>
                   <div class="col-md-6">
                    <b-form-group horizontal label="Category">
                    <b-form-select v-model="category" class="mb-3">
                    <option value="Government">Government</option>
                    <option value="Private">Private</option>
                    <option value="Not for profit">Not for profit</option>
                    </b-form-select>
                  </b-form-group>
                  </div>
                   <div class="col-md-6">
                    <b-form-group horizontal label="Notes">
                    <b-form-input type="text" v-model="notes" required=""></b-form-input>
                  </b-form-group>
                  </div>
                  </div>
                <hr>
                <b-button variant="primary" class="btn-fw" type="submit">Submit</b-button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="js">
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
export default {
  name: 'news',
  components: {
    VueEditor,
    Multiselect,
    vSelect
  },
  data () {
    return {
      name: '',
      lat: '',
      lon: '',
      district: '',
      state: '',
      address: '',
      mobileno: '',
      loading: false,
      error: '',
      category: '',
      notes: ''
    }
  },
  watch: {
    name: function () {
      axios.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + this.name + 'AIzaSyC8tqEonWgsP6GPES7UpwOin2gcgrzhhwA')
        .then(response => {
          if (response.data.results.length === 0) {
            this.address = ''
            this.state = ''
          } else {
            this.district = response.data.results[0].address_components[0].long_name
            this.address = response.data.results[0].formatted_address
            this.lat = response.data.results[0].geometry.location.lat
            this.lon = response.data.results[0].geometry.location.lng
            for (var i = 0; i <= response.data.results[0].address_components.length; i++) {
              if (response.data.results[0].address_components[i].types[0] === 'administrative_area_level_1') {
                this.state = response.data.results[0].address_components[i].long_name
              }
            }
          }
        })
        .catch(e => {
        })
    }
  },
  methods: {
    resetForm () {
      this.name = ''
      this.lat = ''
      this.lon = ''
      this.district = ''
      this.state = ''
      this.address = ''
      this.mobileno = ''
      this.error = ''
      this.category = ''
      this.notes = ''
    },
    onSubmit (evt) {
      evt.preventDefault()
      this.loading = true
      axios({
        method: 'post',
        url: 'https://sarpatnapi.leopardtechlabs.in/hospital/',
        data: {
          name: this.name,
          lat: this.lat,
          lon: this.lon,
          Districtname: this.district,
          State: this.state,
          address: this.address,
          mobileno: this.mobileno,
          category: this.category,
          notes: this.notes
          
        },
        headers: {
          'x-auth-token': localStorage.getItem('token')
        }
      })
        .then(response => {
          this.resetForm()
          alert('Successfully Added Hospital')
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          this.error = e.response.data.msg
          alert('Failed')
        })
    }
  }
}
</script>
<style scoped lang="scss">
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  width: 20%;
}
</style>


// WEBPACK FOOTER //
// src/views/forms/addhospital.vue